import type {
  AccessAction,
  AccessGrants,
  AccessRole,
  DictionaryEntry,
  HierarchyNode,
  RelatedObject,
} from '@/components/object-relations/relationData';
export const RELATIONS_HOME = '/design/object-relations';
export const CANDIDATES: RelatedObject[] = [
  {
    id: 'person-204',
    label: 'Лея Орлова',
    kind: 'Человек',
    description: 'Координатор вымышленной мастерской',
  },
  {
    id: 'review-104',
    label: 'Проверка № 104',
    kind: 'Заявка',
    description: 'Учебный осмотр оборудования',
  },
  {
    id: 'invoice-304',
    label: 'Счёт № 304',
    kind: 'Документ',
    description: 'Демонстрационная поставка',
  },
  {
    id: 'node-silver',
    label: 'Узел «Серебро»',
    kind: 'Узел',
    description: 'Учебная площадка «Север»',
  },
  {
    id: 'vm-fern',
    label: 'Машина «Папоротник»',
    kind: 'VM',
    description: 'Гостевая среда для примера',
  },
  {
    id: 'service-studio',
    label: 'Сервис «Мастерская»',
    kind: 'Сервис',
    description: 'Вымышленный сервис заявок',
  },
];
export const INITIAL_LINKS = ['person-204', 'review-104'];
export const HIERARCHY: HierarchyNode[] = [
  {
    id: 'site-north',
    label: 'Площадка «Север»',
    kind: 'Локация',
    parentId: null,
  },
  {
    id: 'rack-a',
    label: 'Стойка А · 12 мест',
    kind: 'Стойка',
    parentId: 'site-north',
  },
  {
    id: 'node-silver',
    label: 'Узел «Серебро»',
    kind: 'Узел',
    parentId: 'rack-a',
  },
  {
    id: 'vm-fern',
    label: 'Машина «Папоротник»',
    kind: 'VM',
    parentId: 'node-silver',
  },
  { id: 'vm-moss', label: 'Машина «Мох»', kind: 'VM', parentId: 'node-silver' },
  { id: 'node-copper', label: 'Узел «Медь»', kind: 'Узел', parentId: 'rack-a' },
  {
    id: 'rack-b',
    label: 'Стойка Б · 8 мест',
    kind: 'Стойка',
    parentId: 'site-north',
  },
  {
    id: 'site-west',
    label: 'Площадка «Запад»',
    kind: 'Локация',
    parentId: null,
  },
];
export const INITIAL_DICTIONARY: DictionaryEntry[] = [
  { id: 'new', label: 'Новая', tone: 'neutral' },
  { id: 'active', label: 'В работе', tone: 'info' },
  { id: 'waiting', label: 'Нужен ответ', tone: 'warn' },
  { id: 'done', label: 'Завершена', tone: 'success' },
  { id: 'legacy', label: 'Прежняя категория', tone: 'neutral', archived: true },
];
export const ROLES: AccessRole[] = [
  { id: 'owner', label: 'Владелец', description: 'Отвечает за этот объект' },
  { id: 'editor', label: 'Участник', description: 'Работает с заявкой' },
  { id: 'viewer', label: 'Наблюдатель', description: 'Читает результат' },
  { id: 'guest', label: 'Гость', description: 'Приглашённый участник' },
];
export const ACTIONS: AccessAction[] = [
  { id: 'view', label: 'Просмотр' },
  { id: 'comment', label: 'Комментарий' },
  { id: 'edit', label: 'Изменение' },
  { id: 'manage', label: 'Права' },
];
export const INITIAL_GRANTS: AccessGrants = {
  owner: ['view', 'comment', 'edit', 'manage'],
  editor: ['view', 'comment', 'edit'],
  viewer: ['view'],
  guest: [],
};
